import { Spacing } from "types/Spacing";

export const COLUMN_ORDER = "14rem minmax(30rem, 2fr) 12rem";
export const COLUMN_GAP: Spacing = "large";
